import React from 'react'
import { Calendar } from 'primereact/calendar'

const YearEditor = ({ options, validationErrors }) => {
    const rowIndex = options.rowIndex
    return (
        <Calendar
            value={options.value ? new Date(options.value, 0, 1) : null}
            onChange={(e) => options.editorCallback(e.target.value instanceof Date ? e.target.value.getFullYear() : e.target.value)}
            view="year"
            dateFormat="yy"
            className={validationErrors[rowIndex] && validationErrors[rowIndex][options.field] ? 'p-invalid' : ''}/>
    )
}

export default YearEditor
